import { createStore, combineReducers } from "redux";
import Menustore from "./Menustore";
import Sidebarstore from "./Sidebarstore";
import Planservices from "./Planservices";
const Store = createStore(
  combineReducers({ Menustore, Sidebarstore, Planservices })
);
export default Store;
